import React from 'react';
import type { FrillWidget } from '@utils/customTypes';

export function useFrillWidget() {
  const [widgetRef, setWidgetRef] = React.useState<FrillWidget | null>(null);

  React.useEffect(() => {

    if (!window.Frill) { return; }

    // This is an async function, but we're not going to use the resolved result directly,
    // instead we assign the promise to a variable so we can destroy it in the hook cleanup.
    const widget = window.Frill('widget', {
      // Put your Widget key here
      key: 'widget_DnZEAZ_ybqzGi',
      callbacks: {
        onReady(widget) {
          setWidgetRef(widget);
          // widgetRef.current = widget;
          // You can subscribe to widget events like so, don't forget to unsubscribe though.
          // const unsubscribe = widgetRef.current.events.on('badgeCount', console.log)
        },
      },
    });

    return () => {
      setWidgetRef(null);
      // widgetRef.current = null;
      // Calling destroy will also remove the widget from the DOM
      if (widget && widget.destroy) {
        widget.destroy();
      }
    };
  }, []);

  return widgetRef;
}
